import { capitalizeFirstLetter } from 'utils';
import { codeList } from '../utils/codeList';
import { useLingui } from '@lingui/react';

export type Children = keyof typeof codeList;

type CodesProps = {
  text?: string;
  capitalize?: boolean;
};

export const Codes = ({ text, capitalize }: CodesProps) => {
  const { _ } = useLingui();
  const realText = codeList[text as keyof typeof codeList];

  if (!realText && capitalize) {
    return capitalizeFirstLetter(text);
  }
  if (!realText) {
    return text;
  }

  return <>{_(realText)}</>;
};
